import { AsyncHorizontalNavJira } from '@atlassian/jira-horizontal-nav/src/async.tsx';
import { businessProjectLayout } from '@atlassian/jira-business-project-layout/src/index.tsx';
import { embeddedIssuePreloadLayoutBuilder } from '@atlassian/jira-issue-preload-layout/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarCore from '@atlassian/jira-navigation-apps-sidebar-core/src/async.tsx';
import { ThemedLazySkeleton } from '@atlassian/jira-project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { composeLayouts } from '@atlassian/jira-route-layout/src/GlobalComponent.tsx';
import { BUSINESS_BOARD, JIRA_BOARD } from '@atlassian/jira-capabilities/src/constants.tsx';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { workflowIssuesResource } from '@atlassian/jira-router-resources-business-board-workflow-issues/src/index.tsx';
import { getProjectViewResources } from '@atlassian/jira-router-resources-business-common/src/index.tsx';
import { jiraBusinessBoardRoute } from '@atlassian/jira-router-routes-business-board-routes/src/jiraBusinessBoardRoute.tsx';
import { boardPageEntryPoint } from '@atlassian/jira-router-routes-board-entries/src/ui/board/index.tsx';
import { boardPageEntryPoint as legacyBoardPageEntryPoint } from './ui/board/index.tsx';

export const jiraBusinessBoardRouteEntry = createEntry(jiraBusinessBoardRoute, () => ({
	group: 'classic-business',
	ufoName: 'jwm.jwm-board',

	layout: composeLayouts(
		businessProjectLayout,
		embeddedIssuePreloadLayoutBuilder([{ query: ['selectedIssue'] }]),
	),

	skeleton: ThemedLazySkeleton,

	navigation: {
		menuId: MENU_ID.PROJECTS,
		// delete when cleaning up getWillShowNav4
		sidebar: AsyncSidebarCore,
		horizontal: AsyncHorizontalNavJira,
	},

	resources: [...getProjectViewResources(), workflowIssuesResource],

	preloadOptions: {
		earlyChunks: expValEquals('board_harmonisation_m2', 'enabled', true, false)
			? []
			: ['business-board-early-entry'],
	},

	entryPoint: () =>
		expValEquals('board_harmonisation_m2', 'enabled', true, false)
			? boardPageEntryPoint
			: legacyBoardPageEntryPoint,
	supportsPreviewPanel: true,

	meta: {
		capability: expValEquals('board_harmonisation_m2', 'enabled', true, false)
			? JIRA_BOARD
			: BUSINESS_BOARD,
	},

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-business-board-entries/src/jiraBusinessBoardRouteEntry.tsx',
			whichExportToUse: 'jiraBusinessBoardRouteEntry',
		},

		enabled: true,
	},
}));
